import * as React from 'react';
import { SVGProps } from 'react';

const SvgTarget = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M20.18 26.247a5.291 5.291 0 0 1-3.757-1.583 5.482 5.482 0 0 1-1.572-3.827A5.478 5.478 0 0 1 16.417 17a5.286 5.286 0 0 1 3.763-1.585c1.41 0 2.763.568 3.763 1.584a5.473 5.473 0 0 1-.006 7.667 5.286 5.286 0 0 1-3.757 1.581Z"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M20.18 31.186a10.122 10.122 0 0 1-7.194-3.03 10.466 10.466 0 0 1-2.998-7.318 10.466 10.466 0 0 1 2.994-7.327 10.122 10.122 0 0 1 7.198-3.035 10.117 10.117 0 0 1 7.2 3.033 10.461 10.461 0 0 1 2.991 7.328 10.465 10.465 0 0 1-2.998 7.319 10.121 10.121 0 0 1-7.193 3.03Z"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M20.18 36.125a14.952 14.952 0 0 1-10.63-4.478 15.449 15.449 0 0 1-4.425-10.81 15.45 15.45 0 0 1 4.42-10.817A14.952 14.952 0 0 1 20.18 5.537a14.952 14.952 0 0 1 10.635 4.483 15.45 15.45 0 0 1 4.42 10.818 15.449 15.449 0 0 1-4.425 10.809 14.952 14.952 0 0 1-10.63 4.478Z"
    />
    <path
      fill={props.fill}
      d="M20.18 20.809 34.769 5.997 31.33 2.5 20.194 13.81l-.014 6.999Z"
    />
  </svg>
);

export default SvgTarget;
